// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightLanding-cls1_x9g","cls2":"CiterightLanding-cls2_U6H CiterightLanding-cls1_x9g"};